/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { OpportunityEntity } from '@axiom/domain';
/**
 * Response projection of the Opportunity entity. Extends OpportunityEntity
 * (inherits `static key = 'Opportunity'`), so this projection and the full
 * Opportunity entity merge into the same normalized cache record.
 * dark-roast DTO: OpportunitySearchResultDto
 * also used by readUsersOpportunitiesSearch
 */
export class ReadOpportunitiesSearchResponseEntity extends OpportunityEntity {
  override isFulfillmentActive: boolean | null = null;
  timeToSubmission: Record<string, unknown> | null = null;
}